<template>
  <div class="animated fadeIn">
    <b-card header="Devices">
      <div slot="header">
        <div class="d-flex justify-content-between">
          <div><strong>Devices</strong></div>
        </div>
      </div>
      <b-row v-if="admin.level <= 1">
        <b-col md="12" class="pb-4">
          <router-link class="btn btn-primary" to="register">
            <i class="fa fa-plus"></i>&nbsp;Add New
          </router-link>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="6" class="my-1">
          <div class="d-flex">
            <div class="d-flex">
              <div class="pt-1">Per Page:</div>
              <b-form-group class="mb-0 pl-2">
                <b-form-select :options="pageOptions" v-model="perPage" class="mb-1" />
              </b-form-group>
            </div>
            <div class="d-flex pl-3">
              <div class="pt-1">Company:</div>
              <b-form-group class="mb-0 pl-2">
                <b-form-select :options="companyOptions" v-model="company" class="mb-1"  />
              </b-form-group>
            </div>
          </div>
        </b-col>
        <b-col md="6" class="my-1">
          <div class="float-right">
            <div class="d-flex">
              <div class="pt-1">Search:</div>
              <b-form-group class="mb-0 pl-2">
                <b-input-group class="mb-1">
                  <b-form-input v-model="filter" placeholder="Type to Search"  />
                </b-input-group>
              </b-form-group>
            </div>
          </div>
        </b-col>
      </b-row>
      <div class="row">
        <b-col md="12" class="my-1">
          <b-table show-empty
                   striped
                   responsive="sm"
                   :items="filteredDevices"
                   :fields="filteredFields"
                   :current-page="currentPage"
                   :per-page="perPage"
                   :filter="filter"
                   @filtered="onFiltered"
            >
            <template slot="device" slot-scope="data">
              <router-link :to="'' + data.item.device_id">
                {{data.value.device_name}}
              </router-link><br />
              {{data.value.company_name}}
            </template>
            <template slot="address" slot-scope="data">
              {{data.value.street_address}}
              {{data.value.city}},
              {{data.value.province}}
              {{data.value.postal_code}}
            </template>
            <template slot="email" slot-scope="data">
              <router-link class="btn btn-dark btn-block send-email" :to="'../promotions/create?device_id=' + data.item.device_id">
                <i class="fa fa-envelope"></i>&nbsp;Send Email
              </router-link>
            </template>
            <template slot="edit" slot-scope="data">
              <router-link class="btn btn-success btn-block" :to="'edit/' + data.item.device_id">
                <i class="fa fa-edit"></i>&nbsp;Edit
              </router-link>
            </template>
            <template slot="delete" slot-scope="data">
              <b-button block variant="danger" @click="confirmDelete(data.item.device_id)">
                <i class="fa fa-trash"></i>&nbsp;Delete
              </b-button>
            </template>
          </b-table>
          <b-row>
            <b-col md="6" class="my-1">
              Showing {{ showingFrom }} - {{ showingTo }} of {{ totalRows }} devices
            </b-col>
            <b-col md="6" class="my-1">
              <div class="float-right">
                <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next" hide-goto-end-buttons />
              </div>
            </b-col>
          </b-row>
        </b-col>
      </div>
      <b-row v-if="admin.level <= 1">
        <b-col md="12" class="pb-4">
          <router-link class="btn btn-primary" to="register">
            <i class="fa fa-plus"></i>&nbsp;Add New
          </router-link>
        </b-col>
      </b-row>
    </b-card>
    <modal name="confirm-delete-device" height="auto" :adaptive="true" @before-open="deleteDeviceOpen" style="z-index: 10000;">
      <div class="container">
        <b-row class="row-top-delete">
          <b-col xs="10" class="my-1">
            <h2>Delete Device</h2>
          </b-col>
          <b-col xs="2" class="my-1">
            <button type="button" class="close" @click="$modal.hide('confirm-delete-device')" aria-hidden="true">&times;</button>
          </b-col>
        </b-row>
        <b-row class="row-middle-delete">
          <b-col xs="12" class="my-1">
            <p>Are you sure you want to delete this device? This process cannot be undone.</p>
          </b-col>
        </b-row>
        <b-row class="row-bottom-delete">
          <b-col xs="12" class="my-1">
            <div class="d-flex float-right modal-buttons">
              <b-button @click="$modal.hide('confirm-delete-device')">Cancel</b-button>
              <button class="btn btn-danger btn-delete" @click="deleteDevice(); $modal.hide('confirm-delete-device')">
                Delete
              </button>
            </div>
          </b-col>
        </b-row>
      </div>
    </modal>
  </div>
</template>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex'
import filteredFields from './../../mixins/filteredFields'
import getAdmin from './../../mixins/getAdmin'
import onFiltered from './../../mixins/onFiltered'
import showingFrom from './../../mixins/showingFrom'
import showingTo from './../../mixins/showingTo'

export default {
  name: 'Devices',
  mixins: [
    filteredFields,
    getAdmin,
    onFiltered,
    showingFrom,
    showingTo
  ],
  data: () => {
    return {
      admin: {},
      company: '',
      companyOptions: [],
      fields: [
        {key: 'device'},
        {key: 'address'},
        {key: 'edit'},
        {key: 'delete'}
      ],
      pageOptions: [ 5, 10, 15, 20, 25, 50 ],
      currentPage: 1,
      perPage: 5,
      totalRows: 0,
      filter: null
    }
  },
  computed: {
    /**
     * Filters devices based on company name to enable filtering by search and company.
     */
    filteredDevices () {
      let filtered = this.devices.filter((el) => {
        return el.device.company_name.toLowerCase().indexOf(this.company.toLowerCase()) > -1
      })

      return filtered
    },
    ...mapGetters([
      'devices'
    ])
  },
  watch: {
    /**
     * Updates the total number of devices whenever devices array is updated.
     */
    devices () {
      this.totalRows = this.devices.length
    }
  },
  methods: {
    /**
     * Opens up a modal box to confirm deletion of the device.
     * @param {integer} index - The index of the device in the devices array.
     * @param {integer} id - The id of the device selected to be deleted.
     */
    confirmDelete (id) {
      this.$modal.show('confirm-delete-device', {id})
    },
    /**
     * Dispatches the deleteDevice action in the Vuex store to soft delete a device in the backend API.
     */
    deleteDevice () {
      this.$store.dispatch('deleteDevice', {
        device_id: this.device_id,
        notify: this.$notify,
        level: this.admin.level
      })
    },
    /**
     * Function that is evoked when delete modal box is opened.
     * @param {object} event - The event object that is fired.
     */
    deleteDeviceOpen (event) {
      this.device_id = event.params.id
    },
    /**
     * Dispatches an event to get all the devices the authenticated admin has access to.
     */
    getDevices () {
      if (this.admin.level === 0) {
        this.$store.dispatch('getAllDevices')
      } else {
        this.$store.dispatch('getAdminDevices')
      }
    },
    /**
     * Gets all companies from backend API that fall under the authenticated admins organization and that the admin has access to.
     */
    getOrganizationCompanies () {
      let self = this

      axios.get(`${process.env.VUE_APP_API_URL}api/companies`, {
        headers: {
          'x-access-token': localStorage.getItem('user-token')
        }
      })
        .then(function (response) {
          let data = response.data.data
          let companies = ['']

          for (let i = 0; i < data.length; i++) {
            companies.push(data[i]['name'])
          }

          self.companyOptions = companies
        })
        .catch(function (error) {
          console.log(error)
        })
    }
  },
  async mounted () {
    await this.getAdmin()
    this.getDevices()
    this.getOrganizationCompanies()
  }
}
</script>
